module.exports = __webpack_public_path__ + "img/case5.5cc6b9d3.png";